import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NotificationService } from '../../../features/notifications/services/notification.service';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../public/services/storage.service';
import { KeycloakAuthService } from '../../../public/services/keycloak-auth.service';
import { CommunicationService } from '../../../features/communications/services/communication.service';
import { FeatureFlagService } from '../../../core/services/feature-flag.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() toggleNotificationBar = new EventEmitter<boolean>();
  @Output() toggleCommunicationBar = new EventEmitter<boolean>();

  notificationCount: number = 0;
  notificationFromSRSCount: number = 0;

  subs: Subscription[] = [];
  userInfo: any | null = null;

  constructor(
    private notificationService: NotificationService,
    private storage: StorageService,
    private keycloakAuth: KeycloakAuthService,
    private comService: CommunicationService,
    private featureFlags: FeatureFlagService
  ) {}

  ngOnInit(): void {
    this.subs.push(this.notificationService.updateCount$.subscribe((resp) => {
      this.notificationCount = resp;
    }));

    this.userInfo = this.storage.getUser();
    if (!this.userInfo && this.keycloakAuth.isLoggedIn()) {
      this.keycloakAuth.loadUserProfile().then((profile) => {
        if (profile) {
          this.storage.saveUser(profile);
          this.userInfo = profile;
        }
      });
    }
    this.subs.push(
      this.comService.unreadCount$.subscribe(resp => {
        this.notificationFromSRSCount = resp;
      })
    )
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onShowNotifications() {
    this.toggleNotificationBar.emit();
  }

  onShowCommunications() {
    this.toggleCommunicationBar.emit();
  }

  logOut() {
    this.storage.clear();
    this.keycloakAuth.clearCachedProfile();
    this.keycloakAuth.logout();
  }

  isShowNotif(): boolean {
    return this.featureFlags.isEnabled('INT_NOTIFICATIONS');
  }

  isShowCom(): boolean {
    return this.featureFlags.isEnabled('INT_COMMUNICATION');
  }

}
